export default __webpack_public_path__ + "static/media/1660507234077.f99aab20.jfif";